<template>
    <div>
        <div class="welcome-block">
            <div class="welcome-title-zone"  :style="getThemeStyle">
                <div class="welcome-title">Bienvenue !</div>
            </div>
            <p class="welcome-subtitle">{{ public_name }} vous invite dans sa campagne de détection des talents nouvelle génération !
            </p>
            <p class="welcome-text">
                Une aventure unique mêlant Jeu Vidéo et Neurosciences, pour vous permettre de valoriser vos savoir-être
                (aussi appelés soft skills).
            </p>
            <p class="bullet-points-title">Tout ce dont vous avez besoin pour démarrer votre aventure :</p>
            <div class="bullet-points">
                <div class="bullet">
                    <div class="point" :style="getThemeStyle"></div>
                    <div class="text">Un ordinateur</div>
                </div>
                <div class="bullet">
                    <div class="point" :style="getThemeStyle"></div>
                    <div class="text">Une connexion internet</div>
                </div>
                <div class="bullet">
                    <div class="point" :style="getThemeStyle"></div>
                    <p class="text">Un environnement propice à la concentration</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {  computed } from "vue";

var props = defineProps({
  public_name:{
    type: String,
  },
  text_colour:{
    type: String,
  },
  elem_colour:{
    type: String,
  },
});

const getThemeStyle = computed(() => {

    var bgColour = "#f2cb36";
    var textColour = "#000000";

    return {
        'background-color': props.elem_colour ? props.elem_colour : bgColour,
        'color': props.text_colour ? props.text_colour : textColour,
    };
});

//
</script>

<style scoped>
.welcome-block {
    display: flex;
    flex-direction: column;
    max-width: 750px;
    align-items: flex-start;
    gap: 24px;
    position: relative;
    padding: 18px;
    min-width: 400px;
    margin-top: 8vh;
}

.welcome-title-zone {
    display: inline-flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 16px;
    position: relative;
    flex: 0 0 auto;
}

.welcome-title {
    position: relative;
    width: fit-content;
    margin-top: -1.00px;
    font-family: "Bio Sans-Bold", Helvetica;
    font-weight: 700;
    color: #ffffff;
    font-size: 24px;
    letter-spacing: 0;
    line-height: normal;
}

.welcome-subtitle {
    position: relative;
    align-self: stretch;
    font-family: "Bio Sans-Bold", Helvetica;
    font-weight: 700;
    color: #ffffff;
    font-size: 32px;
    letter-spacing: 0.32px;
    line-height: 40.6px;
}

.welcome-text {
    position: relative;
    align-self: stretch;
    font-family: "Bio Sans-Regular", Helvetica;
    font-weight: 400;
    color: #ffffff;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20.3px;
}

.bullet-points-title {
    align-self: stretch;
    font-family: "Bio Sans-Bold", Helvetica;
    font-weight: 700;
    color: #ffffff;
    font-size: 20px;
}

.bullet-points {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 0px 0px 0px 24px;
    position: relative;
    align-self: stretch;
    width: 100%;
    flex: 0 0 auto;
}

.bullet {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    align-self: stretch;
    width: 100%;
    flex: 0 0 auto;
}

.bullet .point {
    width: 12px;
    height: 12px;
    border-radius: 6px;
}

.bullet .text {
    color: #ffffff;
}
</style>
